<template>
  <material-card
    :title="`${ $t('Shifts') }`"
    color="dover-blue">
    <v-form
      ref="form"
      v-model="isValidationOk"
      lazy-validation>
      <v-container
        py-0
        fill-height
        fluid
        grid-list-xl>
        <v-layout
          wrap>
          <v-flex
            xs12
            md2>
            <MaglinkComponentTankList
              :loading="progessBar.loading"
              :filters="filters"
              :tanks="tanks" />
          </v-flex>
          <v-flex
            xs12
            md2>
            <v-switch
              :disabled="progessBar.loading"
              v-model="filters.all"
              :label="`${ $t('All tanks') }`"
              class="dover-input"/>
          </v-flex>
          <v-flex
            xs12
            md2>
            <MaglinkComponentDatePicker
              :component-key="1"
              :rules-is-date="rules.isDate"
              :initial-date="dateFromToday(-7)"
              :date-label="getDateLabel('From')"
              :date-format="systemSettings.dateFormat"
              :loading="progessBar.loading"
              :clear-date="true"
              @getDate="onGetDate"
              @checkDates="onCheckDates"/>
          </v-flex>
          <v-flex
            xs12
            md2>
            <MaglinkComponentDatePicker
              :component-key="2"
              :rules-is-date="rules.isDate"
              :initial-date="dateFromToday(0)"
              :date-label="getDateLabel('To')"
              :date-format="systemSettings.dateFormat"
              :loading="progessBar.loading"
              :clear-date="true"
              @getDate="onGetDate"
              @checkDates="onCheckDates"/>
          </v-flex>
          <v-flex
            xs12
            md2
            text-xs-right>
            <v-btn
              :disabled="!isValidationOk || progessBar.loading"
              small
              class="mx-0 font-weight-light"
              color="dover-blue"
              @click="applyFilter">
              {{ $t('Load') }}
            </v-btn>
          </v-flex>
          <v-flex
            xs12
            md2
            text-xs-right>
            <MaglinkComponentCsvExportButton
              :is-validation-ok="isValidationOk"
              :loading="progessBar.loading"
              @csvExport="csvExport" />
          </v-flex>
          <v-flex
            xs12
            md12
            lg12>
            <MaglinkComponentLoadingBar
              :loading="progessBar.loading"
              :indeterminate="false"
              :max-value="progessBar.maxValue"
              :value="progessBar.currentValue" />
            <span>{{ itemCountLabel }}</span>
            <hr>
          </v-flex>
          <v-flex
            v-show="tableFilled"
            xs12
            sm12
            text-xs-center>
            <v-btn-toggle
              v-model="selectedColumns"
              multiple
              @change="onColumnSelected()">
              <v-btn
                v-for="(item) in columnsOptions"
                :key="item.index"
                :value="item.index"
                text
                small
                color="dover-blue">
                {{ item.desc }}
              </v-btn>
            </v-btn-toggle>
          </v-flex>
          <v-flex
            xs12
            md12>
            <v-data-table
              :headers="headers"
              :items="dataSource"
              :no-data-text="`${ Maglink.NoDataMessage(false) }`"
              :no-results-text="`${ Maglink.NoDataMessage(true) }`"
              hide-actions>
              <template
                slot="headerCell"
                slot-scope="{ header }">
                <span
                  class="dover-light-blue-color"
                  v-text="header.text" />
                <br>
                <span
                  class="dover-light-blue-color"
                  v-text="header.udm" />
              </template>
              <template
                slot="items"
                slot-scope="{ index, item }">
                <tr
                  :style="{ backgroundColor: backColor(index) }"
                  width="100%"
                  class="text-xs-left">
                  <td
                    v-for="(hd) in headers"
                    :key="hd.index"
                    :value="hd.index"
                    :class="getStyle(hd)"
                    nowrap>{{ getValue(hd, item) }}</td>
                </tr>
              </template>
            </v-data-table>
          </v-flex>
        </v-layout>
      </v-container>
    </v-form>
  </material-card>
</template>

<script>
export default {
  props: {
    tanks: {
      type: Array,
      required: true,
      default: () => []
    },
    systemSettings: {
      type: Object,
      required: true,
      default: () => {}
    },
    options: {
      type: Object,
      required: true,
      default: () => {}
    },
    siteInfo: {
      type: Object,
      required: true,
      default: () => {}
    }
  },
  data: () => ({
    isValidationOk: false,
    progessBar: {
      loading: false,
      maxValue: 100,
      currentValue: 0
    },
    rules: {
      isDate: [ v => true ]
    },
    columns: [],
    columnsOptions: [],
    selectedColumns: [],
    tableFilled: false,
    itemCountLabel: '',
    allHeaders: [],
    headers: [],
    dataSource: [],
    filters: {
      all: false,
      number: 1,
      type: 0,
      fromDay: '',
      toDay: ''
    },
    volUdm: '',
    levelUdm: '',
    tempUdm: ''
  }),
  mounted () {
    var currentDate = new Date()
    this.filters.toDay = currentDate.toISOString().substr(0, 10)

    currentDate.setDate(currentDate.getDate() - 7)
    this.filters.fromDay = currentDate.toISOString().substr(0, 10)

    this.columnsOptions = []
    this.columnsOptions.push({ index: 1, desc: this.$t('Volume') })
    this.columnsOptions.push({ index: 2, desc: this.$t('TC volume') })
    this.columnsOptions.push({ index: 3, desc: this.$t('Levels') })
    this.columnsOptions.push({ index: 4, desc: this.$t('Weight') })
    // this.columnsOptions.push({ index: 5, desc: this.$t('Density') })
    this.columnsOptions.push({ index: 6, desc: this.$t('Temperature') })
    this.columnsOptions.push({ index: 7, desc: this.$t('Ullage') })
    this.columnsOptions.push({ index: 8, desc: this.$t('Water') })
    this.columnsOptions.push({ index: 9, desc: this.$t('Delivery') })
    // this.columnsOptions.push({ index: 10, desc: this.$t('Sales') })

    this.selectedColumns = [1, 2, 8, 9]

    this.volUdm = this.options.volumeUnits[this.systemSettings.volumeUnit || 0].desc
    this.levelUdm = this.options.levelUnits[this.systemSettings.levelUnit || 0].desc
    this.tempUdm = this.options.temperatureUnits.find(c => c.code === this.systemSettings.temperatureUnit).desc

    this.initHeaders(this.volUdm, this.levelUdm, this.tempUdm)

    // this.columns['id'] = { show: true, diff: false, type: '' }
    this.columns['tankNumber'] = { show: true, diff: false, type: '' }
    // this.columns['productFamily'] = { show: false, diff: false, type: '' }

    this.columns['initialTime'] = { show: true, diff: false, type: 'd' }
    this.columns['finalTime'] = { show: true, diff: false, type: 'd' }

    this.columns['initialProductVolume'] = { show: true, diff: false, type: 'v' }
    this.columns['finalProductVolume'] = { show: true, diff: false, type: 'v' }
    this.columns['diffProductVolume'] = { show: true, diff: true, type: 'v', first: 'initialProductVolume', last: 'finalProductVolume' }

    this.columns['initialProductVolumeComp'] = { show: false, diff: false, type: 'v' }
    this.columns['finalProductVolumeComp'] = { show: false, diff: false, type: 'v' }
    this.columns['diffProductVolumeComp'] = { show: false, diff: true, type: 'v', first: 'initialProductVolumeComp', last: 'finalProductVolumeComp' }

    this.columns['initialProductLevel'] = { show: false, diff: false, type: 'l' }
    this.columns['finalProductLevel'] = { show: false, diff: false, type: 'l' }
    this.columns['diffProductLevel'] = { show: false, diff: true, type: 'l', first: 'initialProductLevel', last: 'finalProductLevel' }

    this.columns['initialWaterVolume'] = { show: true, diff: false, type: 'v' }
    this.columns['finalWaterVolume'] = { show: true, diff: false, type: 'v' }
    this.columns['diffWaterVolume'] = { show: true, diff: true, type: 'v', first: 'initialWaterVolume', last: 'finalWaterVolume' }

    this.columns['initialTemperature'] = { show: false, diff: false, type: 't' }
    this.columns['finalTemperature'] = { show: false, diff: false, type: 't' }
    this.columns['diffTemperature'] = { show: false, diff: true, type: 'v', first: 'initialTemperature', last: 'finalTemperature' }

    // this.columns['initialDensity'] = { show: false, diff: false, type: 'dn' }
    // this.columns['finalDensity'] = { show: false, diff: false, type: 'dn' }
    // this.columns['diffDensity'] = { show: false, diff: true, type: 'dn', first: 'initialDensity', last: 'finalDensity' }

    this.columns['initialProductWeight'] = { show: false, diff: false, type: 'w' }
    this.columns['finalProductWeight'] = { show: false, diff: false, type: 'w' }
    this.columns['diffWeight'] = { show: false, diff: true, type: 'w', first: 'initialProductWeight', last: 'finalProductWeight' }

    this.columns['initialUllage'] = { show: false, diff: false, type: 'v' }
    this.columns['finalUllage'] = { show: false, diff: false, type: 'v' }
    this.columns['diffUllage'] = { show: false, diff: true, type: 'v', first: 'initialUllage', last: 'finalUllage' }

    this.columns['finalDeliveryVolume'] = { show: true, diff: false, type: 'v' }
    this.columns['finalDeliveryVolumeComp'] = { show: false, diff: false, type: 'v' }
    // this.columns['deliveryWeight'] = { show: false, diff: false, type: 'w' }

    // this.columns['salesVolume'] = { show: true, diff: false, type: 'v' }
    // this.columns['salesVolumeComp'] = { show: false, diff: false, type: 'v' }
    // this.columns['salesWeight'] = { show: false, diff: false, type: 'w' }

    this.onColumnSelected()
  },
  methods: {
    loadHeaders () {
      this.headers = []
      this.allHeaders.forEach(item => {
        if (this.columns[item.key].show) {
          this.headers.push(item)
        }
      })
    },
    onColumnSelected () {
      let values = []
      this.columnsOptions.forEach(item => {
        let found = this.selectedColumns.indexOf(item.index)
        values[item.index] = (found !== -1)
      })

      this.columns['initialProductVolume'].show = values[1]
      this.columns['finalProductVolume'].show = values[1]
      this.columns['diffProductVolume'].show = values[1]

      this.columns['initialProductVolumeComp'].show = values[2]
      this.columns['finalProductVolumeComp'].show = values[2]
      this.columns['diffProductVolumeComp'].show = values[2]

      this.columns['initialProductLevel'].show = values[3]
      this.columns['finalProductLevel'].show = values[3]
      this.columns['diffProductLevel'].show = values[3]

      this.columns['initialWaterVolume'].show = values[8]
      this.columns['finalWaterVolume'].show = values[8]
      this.columns['diffWaterVolume'].show = values[8]

      this.columns['initialTemperature'].show = values[6]
      this.columns['finalTemperature'].show = values[6]
      this.columns['diffTemperature'].show = values[6]

      /*
      this.columns['initialDensity'].show = values[5]
      this.columns['finalDensity'].show = values[5]
      this.columns['diffDensity'].show = values[5]
      */

      this.columns['initialProductWeight'].show = values[4]
      this.columns['finalProductWeight'].show = values[4]
      this.columns['diffWeight'].show = values[4]

      this.columns['initialUllage'].show = values[7]
      this.columns['finalUllage'].show = values[7]
      this.columns['diffUllage'].show = values[7]

      this.columns['finalDeliveryVolume'].show = values[1] && values[9]
      this.columns['finalDeliveryVolumeComp'].show = values[2] && values[9]
      // this.columns['deliveryWeight'].show = values[4] && values[9]

      /*
      this.columns['salesVolume'].show = values[1] && values[10]
      this.columns['salesVolumeComp'].show = values[2] && values[10]
      this.columns['salesWeight'].show = values[4] && values[10]
      */
      this.loadHeaders()
    },
    getStyle (header) {
      let col = this.columns[header.key]
      let result = 'text-xs-right'
      if (col.diff) {
        result += ' font-weight-bold'
      }

      return result
    },
    getValue (header, item) {
      if (header === undefined) return 'undefined'

      // current column settings
      let col = this.columns[header.key]

      // not visible
      if (!col.show) return 'hidden'

      // single value default settings
      let value = item[header.key]

      // diff is needed
      if (col.diff) {
        value = item[col.last] - item[col.first]
      }
      if (col.type === 'v') {
        return this.Maglink.VolumeFormat(value, this.systemSettings.volumeUnit)
      }
      if (col.type === 'l') {
        return this.Maglink.LevelFormat(value, this.systemSettings.levelUnit)
      }
      if (col.type === 't') {
        return this.Maglink.TemperatureFormat(this.Maglink.TemperatureToDisplay(value, this.systemSettings.temperatureUnit), this.systemSettings.temperatureUnit)
      }
      if (col.type === 'd') {
        return this.Maglink.GetCustomDateTime(value, this.systemSettings.dateFormat)
      }
      if (col.type === 'dn') {
        return this.Maglink.DensityFormat(value)
      }
      if (col.type === 'tm') {
        return this.Maglink.RoundFormat(value / 60.0, 1)
      }
      if (col.type === 'w') {
        return this.Maglink.RoundFormat(value, 2)
      }

      // when no type
      return value
    },
    applyFilter () {
      if (!this.onCheckDates()) return

      this.getDataSource()
      this.onColumnSelected()
    },
    backColor (index) {
      return ((index % 2 === 0) ? '#cfdbfb' : 'transparent')
    },
    csvExport (sep) {
      let fileContent = ''
      let title = ''

      if (this.siteInfo.name) {
        fileContent += this.siteInfo.name + '\n'
      }
      if (this.siteInfo.header1) {
        fileContent += this.siteInfo.header1 + '\n'
      }
      if (this.siteInfo.header2) {
        fileContent += this.siteInfo.header2 + '\n'
      }
      if (this.siteInfo.header3) {
        fileContent += this.siteInfo.header3 + '\n'
      }

      // filter
      if (this.filters.all) {
        title = this.$t('All tanks')
        fileContent += title + '\n'
      } else {
        title = this.$t('Tank {0}', [ this.filters.number ])
        fileContent += title + sep
        fileContent += this.tanks[this.filters.number - 1].tankDescription + '\n'
      }

      fileContent += this.$t('Date from') + sep
      fileContent += (this.filters.fromDay !== undefined ? this.filters.fromDay : '') + '\n'
      fileContent += this.$t('Date to') + sep
      fileContent += (this.filters.toDay !== undefined ? this.filters.toDay : '') + '\n'
      fileContent += '\n'

      for (let col = 0; col < this.headers.length; col++) {
        let header = this.headers[col]

        if (!this.columns[header.key].show) {
          continue
        }

        fileContent += header.text + header.udm + sep
      }
      fileContent += '\n'

      for (let row = 0; row < this.dataSource.length; row++) {
        let item = this.dataSource[row]

        for (let col = 0; col < this.headers.length; col++) {
          let header = this.headers[col]

          if (!this.columns[header.key].show) {
            continue
          }

          let value = this.getValue(header, item)
          fileContent += value + sep
        }
        fileContent += '\n'
      }

      let filename = this.$t('Shift report') + '__' + title
      filename += '__' + (this.filters.fromDay !== undefined ? this.filters.fromDay : '')
      filename += '__' + (this.filters.toDay !== undefined ? this.filters.toDay : '')
      filename += '.csv'

      const link = this.Maglink.GetDownloadLinkCSV(fileContent, filename)
      document.body.appendChild(link)
      link.click()
    },
    dateFromToday (days) {
      var currentDate = new Date()
      currentDate.setDate(currentDate.getDate() + days)

      return currentDate
    },
    getDataSource () {
      this.progessBar.loading = true

      this.Maglink.ReportShifts(this.filters)
        .then(response => {
          this.progessBar.maxValue = response.data.length
          this.progessBar.currentValue = 0

          this.dataSource = []
          for (var i = 0; i < response.data.length; i++) {
            this.progessBar.currentValue = i
            this.dataSource.push(this.Maglink.ToDisplay(response.data[i], this.systemSettings.levelUnit, this.systemSettings.volumeUnit))
          }
          this.progessBar.loading = false
          this.itemCountLabel = this.$t('Items: {0}', [ this.dataSource.length ])
          this.tableFilled = this.dataSource.length > 0
        })
        .catch(error => {
          this.progessBar.loading = false
          this.snack('error', error.message)
        })
    },
    getDateLabel (value) {
      return this.$t(value) + ' (' + this.systemSettings.dateFormat + ')'
    },
    onCheckDates () {
      // no check if one date is missing
      if (this.filters.fromDay === undefined) return true
      if (this.filters.toDay === undefined) return true

      if (this.filters.fromDay > this.filters.toDay) {
        this.isValidationOk = false
        this.rules.isDate = [this.$t('Wrong date value')]
      } else {
        this.rules.isDate = [ v => true ]
        this.isValidationOk = true
        this.$refs.form.resetValidation()
      }

      return this.isValidationOk
    },
    onGetDate (componentKey, day) {
      if (componentKey === 1) {
        this.filters.fromDay = day
      } else {
        this.filters.toDay = day
      }

      this.onCheckDates()
    },
    snack (color, message) {
      message = this.$t('Shifts') + ': ' + message
      this.$store.dispatch('showSnackbar', { color, message, show: true })
    },
    initHeaders (volUdm, levelUdm, tempUdm) {
    // IMPORTANT HEADERS SEQUENCE DEFINES COLUMN ORDER IN THE TABLE
      this.allHeaders = [
        // { sortable: false, text: this.$t('ID'), udm: '', align: 'right', key: 'id' },
        { sortable: false, text: this.$t('Tank'), udm: '', align: 'right', key: 'tankNumber' },
        // { sortable: false, text: this.$t('Product family'), udm: '', align: 'right', key: 'productFamily' },

        { sortable: false, text: this.$t('Open'), udm: '', align: 'right', key: 'initialTime' },
        { sortable: false, text: this.$t('Close'), udm: '', align: 'right', key: 'finalTime' },

        { sortable: false, text: this.$t('Opening vol'), udm: ' (' + volUdm + ')', align: 'right', key: 'initialProductVolume' },
        { sortable: false, text: this.$t('Closing vol'), udm: ' (' + volUdm + ')', align: 'right', key: 'finalProductVolume' },
        { sortable: false, text: this.$t('Volume diff'), udm: ' (' + volUdm + ')', align: 'right', key: 'diffProductVolume' },

        { sortable: false, text: this.$t('Opening TC vol'), udm: ' (' + volUdm + ')', align: 'right', key: 'initialProductVolumeComp' },
        { sortable: false, text: this.$t('Closing TC vol'), udm: ' (' + volUdm + ')', align: 'right', key: 'finalProductVolumeComp' },
        { sortable: false, text: this.$t('TC volume diff'), udm: ' (' + volUdm + ')', align: 'right', key: 'diffProductVolumeComp' },

        { sortable: false, text: this.$t('Opening water vol'), udm: ' (' + volUdm + ')', align: 'right', key: 'initialWaterVolume' },
        { sortable: false, text: this.$t('Closing water vol'), udm: ' (' + volUdm + ')', align: 'right', key: 'finalWaterVolume' },
        { sortable: false, text: this.$t('Water diff'), udm: ' (' + volUdm + ')', align: 'right', key: 'diffWaterVolume' },

        { sortable: false, text: this.$t('Delivery'), udm: ' (' + volUdm + ')', align: 'right', key: 'finalDeliveryVolume' },
        { sortable: false, text: this.$t('TC delivery'), udm: ' (' + volUdm + ')', align: 'right', key: 'finalDeliveryVolumeComp' },
        // { sortable: false, text: this.$t('Delivery weight'), udm: ' (kg)', align: 'right', key: 'deliveryWeight' },
        // { sortable: false, text: this.$t('Sales'), udm: ' (' + volUdm + ')', align: 'right', key: 'salesVolume' },
        // { sortable: false, text: this.$t('TC Sales'), udm: ' (' + volUdm + ')', align: 'right', key: 'salesVolumeComp' },
        // { sortable: false, text: this.$t('Sales weight'), udm: ' (kg)', align: 'right', key: 'salesWeight' },

        { sortable: false, text: this.$t('Opening level'), udm: ' (' + levelUdm + ')', align: 'right', key: 'initialProductLevel' },
        { sortable: false, text: this.$t('Closing level'), udm: ' (' + levelUdm + ')', align: 'right', key: 'finalProductLevel' },
        { sortable: false, text: this.$t('Level diff'), udm: ' (' + levelUdm + ')', align: 'right', key: 'diffProductLevel' },

        { sortable: false, text: this.$t('Opening temp'), udm: ' (' + tempUdm + ')', align: 'right', key: 'initialTemperature' },
        { sortable: false, text: this.$t('Closing temp'), udm: ' (' + tempUdm + ')', align: 'right', key: 'finalTemperature' },
        { sortable: false, text: this.$t('Temp diff'), udm: ' (' + tempUdm + ')', align: 'right', key: 'diffTemperature' },

        // { sortable: false, text: this.$t('Opening density'), udm: ' (kg/m3)', align: 'right', key: 'initialDensity' },
        // { sortable: false, text: this.$t('Closing density'), udm: ' (kg/m3)', align: 'right', key: 'finalDensity' },
        // { sortable: false, text: this.$t('Density diff'), udm: ' (kg/m3)', align: 'right', key: 'diffDensity' },

        { sortable: false, text: this.$t('Opening weight'), udm: ' (kg)', align: 'right', key: 'initialProductWeight' },
        { sortable: false, text: this.$t('Closing weight'), udm: ' (kg)', align: 'right', key: 'finalProductWeight' },
        { sortable: false, text: this.$t('Weight diff'), udm: ' (kg)', align: 'right', key: 'diffWeight' },

        { sortable: false, text: this.$t('Opening ullage'), udm: ' (' + volUdm + ')', align: 'right', key: 'initialUllage' },
        { sortable: false, text: this.$t('Closing ullage'), udm: ' (' + volUdm + ')', align: 'right', key: 'finalUllage' },
        { sortable: false, text: this.$t('Ullage diff'), udm: ' (' + volUdm + ')', align: 'right', key: 'diffUllage' }
      ]
    }
  }
}
</script>
